import {
  ADD_TO_CART,
  DELETE_FROM_CART,
  ADD_STUDENT_TO_SHOP_CART,
  DELETE_STUDENT_FROM_SHOP_CART,
  CLEAN_SHOP_CART,
  SET_LASTADDED_ITEM,
  DELETE_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED,
  ADD_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED,
} from "../actions/newCartActions";

const INIT_CART_STATE = {
  loading: true,
  error: null,
  result: [],
  lastAddedItem: {},
};

export default function newCartReducer(state = INIT_CART_STATE, action = {}) {
  switch (action.type) {
    case ADD_TO_CART:
      if (
        !state.result.some(
          (ci) => ci.fortnoxNumber === action.payload.fortnoxNumber
        )
      ) {
        return {
          ...state,
          result: [...state.result, action.payload],
        };
      } else {
        return { ...state };
      }
    case DELETE_STUDENT_FROM_SHOP_CART:
      state.result.find(
        (prod) => prod.fortnoxNumber === action.payload.fortnoxNumber
      ).addedStudents = state.result
        .find((prod) => prod.fortnoxNumber === action.payload.fortnoxNumber)
        .addedStudents.filter((stud) => stud.id !== action.payload.student.id);
      return { ...state };
    case ADD_STUDENT_TO_SHOP_CART:
      state.result
        .find((prod) => prod.fortnoxNumber === action.payload.fortnoxNumber)
        .addedStudents.push(action.payload.student);
      return { ...state };
    case DELETE_FROM_CART:
      const res = state.result.filter(
        (item) => item.fortnoxNumber !== action.payload
      );

      let lastItem = state.lastAddedItem;

      if (lastItem.isPlusPackage) {
        if (lastItem.plusPackage.fortnoxNumber === action.payload) {
          lastItem = lastItem.studentLicense;
        } else {
          lastItem = lastItem.plusPackage;
        }
      } else {
        if (lastItem.fortnoxNumber === action.payload) {
          const firstStudentLicense = res.find(
            (r) => r.type === "StudentLicense"
          );

          if (firstStudentLicense) {
            const matchingPlusLicense = res.find(
              (r) =>
                r.programLicenseId === firstStudentLicense.programLicenseId &&
                r.fortnoxNumber !== firstStudentLicense.fortnoxNumber
            );

            if (matchingPlusLicense) {
              lastItem = {
                isPlusPackage: true,
                plusPackage: matchingPlusLicense,
                studentLicense: firstStudentLicense,
              };
            } else {
              lastItem = firstStudentLicense;
            }
          } else if (res.length > 0) {
            lastItem = res[0];
          } else {
            lastItem = {};
          }
        }
      }

      return {
        ...state,
        result: res,
        lastAddedItem: lastItem,
      };
    case DELETE_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED: {
      let tempResultForRemove = [...state.result];
      let tempLastAddedItemForRemove = { ...state.lastAddedItem };
      tempResultForRemove.find(
        (prod) => prod.fortnoxNumber === action.payload.fortnoxNumber
      ).addedStudents = tempResultForRemove
        .find((prod) => prod.fortnoxNumber === action.payload.fortnoxNumber)
        .addedStudents.filter(
          (stud) => !action.payload.studentIds.includes(stud.id)
        );
      if (tempLastAddedItemForRemove.isPlusPackage) {
        if (
          action.payload.fortnoxNumber ===
          tempLastAddedItemForRemove.plusPackage.fortnoxNumber
        ) {
          tempLastAddedItemForRemove.plusPackage.addedStudents =
            tempLastAddedItemForRemove.plusPackage.addedStudents.filter(
              (stud) => !action.payload.studentIds.includes(stud.id)
            );
        }
      } else {
        tempLastAddedItemForRemove.addedStudents =
          tempLastAddedItemForRemove.addedStudents.filter(
            (stud) => !action.payload.studentIds.includes(stud.id)
          );
      }
      return {
        ...state,
        result: tempResultForRemove,
        lastAddedItem: tempLastAddedItemForRemove,
      };
    }
    case ADD_MANY_STUDENTS_FROM_SHOP_CART_AND_LAST_ADDED: {
      let tempResultForAdd = [...state.result];
      let tempLastAddedItemForAdd = { ...state.lastAddedItem };
      if (!tempLastAddedItemForAdd.isPlusPackage) {
        action.payload.students.forEach((stud) => {
          if (
            !tempLastAddedItemForAdd.addedStudents.some(
              (existingStud) => existingStud.id === stud.id
            )
          ) {
            tempLastAddedItemForAdd.addedStudents.push(stud);
          }
        });
      } else {
        action.payload.students.forEach((stud) => {
          if (
            !tempLastAddedItemForAdd.plusPackage.addedStudents.some(
              (existingStud) => existingStud.id === stud.id
            )
          ) {
            tempLastAddedItemForAdd.plusPackage.addedStudents.push(stud);
          }
        });
      }
      action.payload.students.forEach((stud) => {
        if (
          !tempResultForAdd
            .find((prod) => prod.fortnoxNumber === action.payload.fortnoxNumber)
            .addedStudents.some((existingStud) => existingStud.id === stud.id)
        ) {
          tempResultForAdd
            .find((prod) => prod.fortnoxNumber === action.payload.fortnoxNumber)
            .addedStudents.push(stud);
        }
      });
      return {
        ...state,
        result: tempResultForAdd,
        lastAddedItem: tempLastAddedItemForAdd,
      };
    }
    case CLEAN_SHOP_CART:
      return { ...state, result: [], lastAddedItem: {} };
    case SET_LASTADDED_ITEM:
      return { ...state, lastAddedItem: action.payload };
    default: {
      return {
        ...state,
      };
    }
  }
}
